import { render, staticRenderFns } from "./AdminTipiTariffaView.vue?vue&type=template&id=9f44ae10&"
import script from "./AdminTipiTariffaView.vue?vue&type=script&lang=ts&"
export * from "./AdminTipiTariffaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports